import runAfterPageLoad from "./runAfterPageLoad";

export default function simpleAccordion() {
  runAfterPageLoad(() => {
    $(".simple-accordion").on("click", accordionActions);
  });
}

function accordionActions() {
  const target = $(this).next();
  $(this).toggleClass("open");

  if ($(this).hasClass("open")) {
    target.attr("data-org-height", target.innerHeight());
    target.animate({ height: 0 });
  } else {
    const orgHeight = target.attr("data-org-height");
    target.animate({ height: orgHeight });
  }
}
